//react
import React from "react";

//router
import { Redirect } from "react-router-dom";

//redux
//import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
//import { SchoolsLoaded } from 'redux/actions';

//firebase
import { db } from 'assets/firebase';

// @material-ui/style
import withStyles from "@material-ui/core/styles/withStyles";

// core components
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import Tooltip from "@material-ui/core/Tooltip";

//materialKit components
import GridItem from "components/Grid/GridItem.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CustomSelect from "components/Select/Select.jsx";

//spiffy components
import ConfirmDialog from "components/ConfirmDialog/ConfirmDialog.jsx";
import TaskEditor from "components/TaskEditor/TaskEditor.jsx";

//google Analytics
import ReactGA from 'react-ga';
ReactGA.initialize('UA-54225103-1');

const styles = {
  cardCategoryWhite: {
    "&,& a,& a:hover,& a:focus": {
      color: "rgba(255,255,255,.62)",
      margin: "0",
      fontSize: "14px",
      marginTop: "0",
      marginBottom: "0"
    },
    "& a,& a:hover,& a:focus": {
      color: "#FFFFFF"
    }
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
    "& small": {
      color: "#777",
      fontSize: "65%",
      fontWeight: "400",
      lineHeight: "1"
    }
  }
};

class TaskList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tasks: [],
      ownerFilter: "all",
      statusFilter: "open",
      categoryFilter: "all"
    }
    this.taskUpdated = this.taskUpdated.bind(this);
  }

  componentWillMount() {
    this.refreshTasks();
  }

  taskUpdated() {
    this.refreshTasks();
  }

  byName(a,b) {

    var valueA = a.Name;
    var valueB = b.Name;
  
    if (valueA < valueB)
      return -1;
    if (valueA > valueB)
      return 1;
    return 0;
  }

  refreshTasks() {

    db.getTasks().then(tasks => {
    
      var filtered = [];

      for(var i = 0; i < tasks.length; i++) {
        if(tasks[i].Status === this.state.statusFilter || this.state.statusFilter === 'all') {
            if(tasks[i].Owner === this.state.ownerFilter || this.state.ownerFilter === 'all') {
                if(tasks[i].Category === this.state.categoryFilter || this.state.categoryFilter === 'all') {
                    filtered.push(tasks[i]);
                }
            }
        } 
      }

      filtered.sort(this.byName);
      this.setState({tasks: filtered});
    });
  }

  filterTasks(property, value) {
    if(property === 'Category') {
        this.setState({categoryFilter: value}, () => this.refreshTasks());
    } else if (property === 'Owner') { 
        this.setState({ownerFilter: value}, () => this.refreshTasks());
    } else if (property === 'Status') {
        this.setState({statusFilter: value}, () => this.refreshTasks());
    }
  }

  getCategoryName(task) {
    if(task.Category === 'admin') {
        return "Admin";
    } else if (task.Category === 'content') {
        return "Content";
    } else if (task.Category === 'legal') {
      return "Legal";
    } else if (task.Category === 'marketing') {
        return "Marketing";
    } else if (task.Category === 'sales') {
        return "Sales";
    } else if (task.Category === 'bugs') {
        return "Website Bugs";
    } else if (task.Category === 'features') {
        return "Website Features";
    }
  }

  getOwnerName(task) {
      if(task.Owner === 'michael') {
          return <span style={{color:"green"}}>Michael</span>;
      } else if (task.Owner === 'tanny') {
          return <span style={{color:"blue"}}>Tanny</span>;
      } else if (task.Owner === 'danna') {
        return <span style={{color:"orange"}}>Danna</span>;
    }
  }

  getStatusText(task) {
    if(task.Status === 'open') {
        return <span style={{color:"maroon"}}>Open</span>;
    } else if (task.Status === 'inProgress') {
        return <span style={{color:"black"}}>In Progress</span>;
    } else if (task.Status === 'complete') {
      return <span style={{color:"green"}}>Complete</span>;
    }
  }

  deleteTask(task) {
    db.deleteTask(task.id).then(() => {

      var objs = this.state.tasks;
      for(var i = 0; i < objs.length; i++) {
        if(objs[i].id === task.id) {
          objs.splice(i,1);
          break;
        }
      }
      this.setState({tasks:objs});
    });
  }

  render() {
    const { classes } = this.props;

    if (!this.props.user.authenticated) {
      return <Redirect to='/login' />
    }

    ReactGA.pageview("admin.allthingseq.com/tasks");

    return (
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <Card>
            <CardHeader color="success">
              <GridContainer>
                <GridItem xs={12} sm={12} md={10}>
                  <h4 className={classes.cardTitleWhite}>Tasks</h4>
                  <p className={classes.cardCategoryWhite}>
                    
                  </p>
                </GridItem>
                <GridItem xs={12} sm={12} md={2} style={{textAlign:"right"}}>
                  <Tooltip
                        id="tooltip-top-start"
                        title="Add Task"
                        placement="top"
                        classes={{ tooltip: classes.tooltip }}
                    >
                      <TaskEditor onChange={this.taskUpdated}
                        task={{
                          Name: "",
                          Description: "",
                          Status: "open",
                          Category: "",
                          Owner: "",
                          DueDate: "",
                        }} />
                  </Tooltip>
                </GridItem>
              </GridContainer>
            </CardHeader>
            <CardBody>
              <GridContainer>
                <GridItem xs={3}>
                    
                </GridItem>
                <GridItem xs={3}>
                    <CustomSelect
                        labelText="Category"
                        value={this.state.categoryFilter}
                        inputProps={{ placeholder: "Category" }}
                        formControlProps={{ fullWidth: true }}
                        onChange={(e) => this.filterTasks("Category", e.target.value)}
                        options={[
                            {key:"all",label:"All"},
                            {key:"admin",label:"Admin"},
                            {key:"content",label:"Content"},
                            {key:"legal",label:"Legal"},
                            {key:"marketing",label:"Marketing"},
                            {key:"sales",label:"Sales"},
                            {key:"bugs",label:"Website Bugs"},
                            {key:"features",label:"Website Features"},
                        ]}
                    />
                </GridItem>
                <GridItem xs={3}>
                    <CustomSelect
                        labelText="Owner"
                        value={this.state.ownerFilter}
                        inputProps={{ placeholder: "Owner" }}
                        formControlProps={{ fullWidth: true }}
                        onChange={(e) => this.filterTasks("Owner", e.target.value)}
                        options={[
                            {key:"all",label:"All"},
                            {key:"danna",label:"Danna"},
                            {key:"michael",label:"Michael"},
                            {key:"tanny",label:"Tanny"}
                        ]}
                    />
                </GridItem>
                <GridItem xs={3}>
                    <CustomSelect
                        labelText="Status"
                        value={this.state.statusFilter}
                        inputProps={{ placeholder: "Status" }}
                        formControlProps={{ fullWidth: true }}
                        onChange={(e) => this.filterTasks("Status", e.target.value)}
                        options={[
                            {key:"all",label:"All"},
                            {key:"open",label:"Open"},
                            {key:"inProgress",label:"In Progress"},
                            {key:"complete",label:"Complete"}
                        ]}
                    />
                </GridItem>
              </GridContainer>
              <br />
              <Table className={classes.table}>
                <TableHead>
                  <TableRow>
                      <TableCell style={{padding:"3px", maxWidth:"48px"}}>

                      </TableCell>
                      <TableCell>
                        Name
                      </TableCell>
                      <TableCell style={{padding:"6px"}}>
                        Category
                      </TableCell>
                      <TableCell style={{padding:"6px"}}>
                        Owner
                      </TableCell>
                      <TableCell style={{padding:"6px"}}>
                        Due
                      </TableCell>
                      <TableCell style={{padding:"6px"}}>
                        Status
                      </TableCell>
                      <TableCell style={{padding:"3px"}}>
                          
                      </TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                  {this.state.tasks.map(value => (
                    <TableRow key={value.id} className={classes.tableRow}>
                      <TableCell className={classes.tableActions} style={{padding:"3px", maxWidth:"48px"}}>
                        <Tooltip
                          id="tooltip-top"
                          title="Edit Task"
                          placement="top"
                          classes={{ tooltip: classes.tooltip }}
                        >
                         <TaskEditor task={value} onChange={this.taskUpdated}  />
                        </Tooltip>
                      </TableCell>
                      <TableCell className={classes.tableCell}>
                        {value.Name}
                      </TableCell>
                      <TableCell className={classes.tableCell} style={{padding:"6px"}}>
                        {this.getCategoryName(value)}
                      </TableCell>
                      <TableCell className={classes.tableCell} style={{padding:"6px"}}>
                        {this.getOwnerName(value)}
                      </TableCell>
                      <TableCell className={classes.tableCell} style={{padding:"6px"}}>
                        {value.DueDate}
                      </TableCell>
                      <TableCell className={classes.tableCell} style={{padding:"6px"}}>
                        {this.getStatusText(value)}
                      </TableCell>
                      <TableCell className={classes.tableActions} style={{padding:"3px"}}>
                        <Tooltip id="tooltip-top-start" title="Delete Task" placement="top" classes={{ tooltip: classes.tooltip }} >
                          <ConfirmDialog header="Confirm Delete" description="Are you sure you want to delete this task? This action cannot be undone." confirmed={() => this.deleteSchool(value)} />
                        </Tooltip>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    );
  }
}

const mapStateToProps = state => {
  return state;
}

TaskList = connect(mapStateToProps)(TaskList);
export default withStyles(styles)(TaskList);



// WEBPACK FOOTER //
// ./src/views/TaskList/TaskList.jsx